import React, { useState } from 'react';
import PoiDialog from './pois/PoiDialog';
import PoiGroupDialog from './pois/PoiGroupDialog';

/**
 * Shows either the PoiDialog or PoiGroupDialog box depending on user selection
 * 
 * @param {Object[]} data - data from the info window in usePoiMap
 * @param {Object} poiDialogHandlers - dialog box handler functions from usePoiMap
 * @param {number} selectedPoiJob - selected job, used for api calls
 * @param {number} selectedPoiGroup - selected group in map component - for adding new poi to group
 * @param {string} activeComponent - tells MapDialog which dialog box  to display, comes from usePoiMap state
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - Map
 */
const MapDialog = ({ data, poiDialogHandlers, selectedPoiJob, selectedPoiGroup, activeComponent, userContext }) => {
  const [poiId, setPoiId] = useState(data.POIID)
  
    //render components depending on which button selected
    const componentMap = {
        PoiDialog: <PoiDialog 
            data={data}
            poiId={poiId}
            setPoiId={setPoiId}
            poiDialogHandlers={poiDialogHandlers}
            selectedPoiJob={selectedPoiJob}
            selectedPoiGroup={selectedPoiGroup}
            userContext={userContext}
        />,
        PoiGroupDialog: <PoiGroupDialog
            poiName={data.AltPOI_Name ?? data.POI_Name}
            poiDescription={data.AltDescription ?? data.Description}
            poiId={poiId}
            poiGroupData={data.poiGroups}
            selectedPoiJob={selectedPoiJob}
            poiDialogHandlers={poiDialogHandlers}
        />
    }

  return (
    <>
        {componentMap[activeComponent]}
    </>
 
)
};

export default MapDialog;
